/*
 *
 *  * Copyright (c) 2020 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SafePipe } from './safe.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { SearchPipe } from './search.pipe';
import { FilterPipe } from './filter.pipe';
import { GetDataPipe } from './get-data.pipe';
import { SortPipe } from './sort.pipe';
import { OrderByPipe } from './order-by.pipe';
import { IsTemplateRefPipe } from './is-template-ref.pipe';
import { FilterTagContainerStylePipe } from './filter-tag-container-style.pipe';
import { UniqueValuesPipe } from './unique-values.pipe';

const pipes = [
  SafePipe,
  SafeHtmlPipe,
  SearchPipe,
  FilterPipe,
  GetDataPipe,
  SortPipe,
  OrderByPipe,
  IsTemplateRefPipe,
  FilterTagContainerStylePipe,
  UniqueValuesPipe
];

@NgModule({
  declarations: pipes,
  exports: pipes,
  providers: pipes,
  imports: [CommonModule]
})
export class PipesModule {}

export {
  SafePipe,
  SafeHtmlPipe,
  SearchPipe,
  FilterPipe,
  GetDataPipe,
  SortPipe,
  OrderByPipe,
  IsTemplateRefPipe,
  FilterTagContainerStylePipe,
  UniqueValuesPipe
};
